import { classNameTag } from '../../../utils/class-name-tag';
const buttonTag = (...tags) => classNameTag('Button', ...tags);
const buttonVariant = (variant) => `${variant}-variant`;
const buttonIcon = ({ hasStartIcon, hasEndIcon, }) => {
    if (hasStartIcon && hasEndIcon) {
        return 'start-icon end-icon';
    }
    if (hasStartIcon) {
        return 'start-icon';
    }
    if (hasEndIcon) {
        return 'end-icon';
    }
    return undefined;
};
export const ButtonTags = {
    root: buttonTag('root'),
    iconWrapper: buttonTag('icon-wrapper'),
    contentContainer: buttonTag('content-container'),
    loaderContainer: buttonTag('loader-container'),
    variant: buttonVariant,
    icon: buttonIcon,
};
//# sourceMappingURL=class-name-tags.js.map